<template>
  <div class="dot-spinner">
    <div
      v-for="dotIndex in totalDots"
      :key="dotIndex"
      class="dot-spinner__dot"
    ></div>
  </div>
</template>

<script setup>
defineProps({
  totalDots: {
    type: Number,
    default: 8,
  },
});
</script>
